var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-2"},[_c('CombinerData',{attrs:{"culture-id":_vm.cultureId,"is-history":_vm.isHistory}}),_c('FitHuntModel',{attrs:{"culture-id":_vm.cultureId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }